import type { StyleRule } from '@archipro-design/aria';
import { dropdownSlotClassNames, pxToRem } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';
import { svgIconClassName } from '@archipro-design/icons';

export const ColorOptionPicker: StyleRule = () => ({
    [`& .${dropdownSlotClassNames.itemsList}`]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 33.33%)',
        minWidth: pxToRem(504),
    },
    [`& .ui-dropdown__item`]: {
        padding: 0,
        display: 'flex',
        position: 'relative',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
});

export const OptionIndicator: StyleRule<{ popupOpen: boolean }> = ({
    popupOpen,
}) => ({
    position: 'absolute',
    top: pxToRem(-3),
    left: pxToRem(6),
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    userSelect: 'none',
    [`& .${svgIconClassName}`]: {
        width: pxToRem(32),
        height: pxToRem(32),
        '& svg': {
            width: '100%',
            height: '100%',
            transition: 'transform 300ms',
            transformOrigin: '50% 50%',
            transform: popupOpen
                ? `rotate(59deg) translate(${pxToRem(-2)}, ${pxToRem(1)})`
                : 'rotate(0deg)',
        },
    },
});

export const ColorOptionSelect: StyleRule = ({ theme }) => ({
    position: 'relative',
    cursor: 'pointer',
    paddingLeft: pxToRem(54),
    minHeight: pxToRem(56),
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
        backgroundColor: hex2rgba(
            theme.siteVariables.colors.primitive.black,
            0.06,
        ),
    },
});

export const ColorValue: StyleRule = () => ({
    userSelect: 'none',
});
